import * as Rules from "./Rules";
import { SD } from "../../../Contracts";
export const queryValidators = {
    default: Rules.isValidQuery,
    [SD.QueryTypes.GetSports]: Rules.sportsParams
};
//# sourceMappingURL=index.js.map